import { Component, Input, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNPrescription } from 'src/app/models/cnprescription';
import { SNItemTableService } from 'src/app/snitem-table/snitem-table-interface';

@ManageType('PrescriptionComponent')
@Component({
  selector: 'app-prescription',
  templateUrl: './prescription.component.html',
  styleUrls: ['./prescription.component.scss']
})
export class PrescriptionComponent implements OnInit {

  @Input() prescription: CNPrescription;

  constructor() { }

  ngOnInit(): void {
  }

}
